import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { useMemo, useRef, useState } from "react";
import { Box, FormHelperText, useTheme } from "@mui/material";
import { FormLabel, customInputSxProps } from "../FormInput";
import moment from "moment";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { poperSxProps } from "../../contexts/ThemeContext/getDesignTokens";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import ScheduleIcon from "@mui/icons-material/Schedule";

type DatePickerProps = {
  helperText?: string;
  width?: string;
  fullWidth?: boolean;
  label?: string;
  onChange?: (value: any) => void;
  value?: any;
  required?: boolean;
  disabled?: boolean;
};

const TimePicker = (props: DatePickerProps) => {
  const { width = "15.625rem", fullWidth = true, required, label, helperText, onChange = () => {}, value: initialValue = moment(), disabled = false, ...others } = props;
  const error = !!helperText;

  const [value, setValue] = useState(() => {
    if (typeof initialValue === "string") {
      return moment(initialValue);
    }
    return initialValue || moment();
  });

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box sx={{ width: fullWidth ? "100%" : width }}>
        {label && <FormLabel error={error} label={label} required={required} />}
        <MuiTimePicker
          sx={{ width: "100%" }}
          slotProps={{
            textField: {
              InputProps: {
                fullWidth: true,
                size: "small",
                error: error,
                disabled,
                ...others,
                sx: {
                  ...customInputSxProps,
                },
                startAdornment: (
                  <ScheduleIcon
                    sx={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "text.secondary",
                    }}
                  />
                ),
              },
            },
          }}
          onChange={(e) => {
            setValue(e);
            onChange(e?.toISOString());
          }}
          value={value}
        />
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Box>
    </LocalizationProvider>
  );
};
export default TimePicker;
